module.exports = __webpack_public_path__ + "startpage-746fed5a/aufloesung-c53e98b75de2f4c5d2067052c2df03ff.jpeg";